export var ConnectorStrategy;
(function (ConnectorStrategy) {
    ConnectorStrategy[ConnectorStrategy["AUTO"] = 0] = "AUTO";
    ConnectorStrategy[ConnectorStrategy["EXTENSION"] = 1] = "EXTENSION";
    ConnectorStrategy[ConnectorStrategy["WALLET_CONNECT"] = 2] = "WALLET_CONNECT";
})(ConnectorStrategy || (ConnectorStrategy = {}));
